"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryDecodeDateStrToTime = void 0;
function tryDecodeDateStrToTime(_a) {
    var value = _a.value;
    if (value === undefined || value === null) {
        return value;
    }
    if (typeof value === 'string' || typeof value === 'number') {
        try {
            return new Date(value).getTime();
        }
        catch (_b) { }
    }
    return String(value);
}
exports.tryDecodeDateStrToTime = tryDecodeDateStrToTime;
//# sourceMappingURL=try-decode-date-str-to-time.js.map